import Drawer from "@/wmCompoments/drawer";
import React, { useState } from "react";
import styles from '../styles/detail.module.scss'
import Icon from "@/wmCompoments/Icon";
import { useDeleteFeedback, useGetFeedbackInfo } from "../hooks/api";
import LoadingUI from "@/compoments/loadingUI";
import Image from "@/wmCompoments/image";
import DeleteConfirm from "@/views/accountManagement/dialog/deleteConfirm";
import ErrorMessageDialog from "@/antComponent/errorMessageDialog";

interface Props {
    visible: boolean
    onClose: () => void
    father: HTMLElement | null
    list: any,
    currentIndex: number
    onClickPrevious: () => void
    onClickNext: () => void
    mutateList: ()=>any
}

const Detail = (props: Props) => {

    const { visible, onClose, father, onClickPrevious, onClickNext, list, currentIndex, mutateList } = props

    const { trigger } = useDeleteFeedback()
    const [ deleteVisible, setDeleteVisible ] = useState(false)
    const handleBack = () => {
        onClose()
    }

    const handleDelete = async () => {
        try {
            await trigger({
                id: list?.[currentIndex]?.id
            })
            await mutateList()
            onClose()
        } catch (error: any) {
            ErrorMessageDialog(error?.message ?? JSON.stringify(error))
        }
    }

    const { details, isLoading, error, mutate } = useGetFeedbackInfo(list?.[currentIndex]?.id)

    return <Drawer
        visible={visible}
        onClose={onClose}
        placement="right"
        maskClosable={true}
        getContainer={() => father!}
        width={'100%'}
        className={styles.drawer}
    >
        <div className={styles.warpper}>
            <div className={styles.title}>
                <div onClick={handleBack}>
                    <Icon name={'icon-general-arrow-line-left'} />
                </div>

                <span>详情</span>
            </div>

            <div className={styles.topWarpper}>

                <div className={styles.imgWarpper}>
                    <img src={list?.[currentIndex]?.iconUrl} />
                    <span>{list?.[currentIndex]?.title}</span>
                    <Icon name={'icon-general-delete'} onClick={()=>{
                        setDeleteVisible(true)
                    }}/>
                    <Icon name={'icon-general-arrow-line-left'} onClick={() => {
                        onClickPrevious()
                    }} />
                    <Icon name={'icon-general-arrow-line-right'} onClick={() => {
                        onClickNext()
                    }} />
                </div>
            </div>
            <LoadingUI height={500} data={details} loading={isLoading} error={error} retryFunc={() => {
                mutate()
            }}>
                <div className={styles.list}>
                    {
                        details?.list?.map((v, index) => {


                            const images = v?.picUrls === '' ? [] : v?.picUrls?.split(',') ?? []

                            return <div key={v.feedbackId + index} className={styles.detailsWarpper}>
                                <div className={styles.header}>
                                    <img src={v.userAvatar} />
                                    <span>{v.userName}</span>
                                </div>
                                <div className={styles.comment}>
                                    {v.comment}
                                </div>
                                {!!images?.length && <div className={styles.imageWapper}>
                                    {

                                        images.map((v, i) => {
                                            return <div key={i} className={styles.itemImage}>
                                                <Image src={v} preview={true} />
                                            </div>
                                        })
                                    }
                                </div>}
                                <div className={styles.time}>
                                    {v.createdAt}
                                </div>
                            </div>
                        })
                    }
                </div>
            </LoadingUI>
        </div>

        <DeleteConfirm visible={deleteVisible} onClose={()=>{
            setDeleteVisible(false)
        }} onSubmit={handleDelete}/>
    </Drawer>
}


export default Detail

